<script setup lang="ts">
const props = defineProps<{
    generatedSnippet?: string
}>()

const toast = useToast()

function copy() {
    if ('navigator' in window) {
        navigator.clipboard.writeText(props.generatedSnippet || '')
        toast.add({
            title: 'Copied to clipboard!',
        description: 'You can now paste it in your meta description tag.',
            color: 'success',
        })
    } else {
        toast.add({
            title: 'Error',
            description: 'Your browser does not support clipboard copying.',
            color: 'error',
        })
    }
}
</script>

<template>
    <div class="shadow-lg rounded-[calc(var(--ui-radius)*2)] bg-[var(--ui-bg)] p-6 text-left">
        <div class="flex flex-col gap-2 max-w-[652px]">
            <div class="select-none flex items-center gap-3 blur-[2px]">
                <div class="size-7 rounded-full ring ring-[var(--ui-border)]">
                    <UIcon class="size-7" name="solar:cat-bold" />
                </div>
                <div class="flex flex-col">
                    <span class="text-sm text-[var(--ui-text-muted)]">Example</span>
                    <span class="text-xs text-[var(--ui-text-dimmed)]">https://example.com &rsaquo; hello</span>
                </div>
            </div>
            <div class="flex flex-col gap-1">
                <p class="select-none text-xl text-[var(--ui-primary)] blur-[2px]">This is the title of your page / blog post</p>
                <p class="text-sm text-[var(--ui-text)]">{{ generatedSnippet || `Here it's gonna be your high-quality snippet for Google! ` }}</p>
            </div>
            <UButton
                v-if="generatedSnippet"
                @click="copy"
                color="neutral"
                class="w-fit mt-2"
                icon="solar:copy-bold"
                variant="outline"
            >
                Copy to clipboard
            </UButton>
        </div>
    </div>
</template>